export const sequenceData = [
    { id: "01", name: "Free Trial" },
    { id: "02", name: "Starter" },
    { id: "03", name: "Premium" },
];

export const steps = ["Account setup", "Billing setup", "Feature setup", "Confirmation"];

